<footer class="spriced-footer" aria-label="Copyright">
  <span class="copyright-text">{{ copyrightText }}</span>
  @if (logoSrc) {
    <img class="partner-logo" [src]="logoSrc" [alt]="logoAlt" />
  }
</footer>
